import { getSnapshot, destroy, detach, getRoot } from '@invisr/mobx-state-tree'
const crudActions = self => {
  function update (key: string|object, val?: any) {
    if (typeof key === 'string') {
      self[key] = val
    } else if (typeof key === 'object') {
      Object.keys(key).filter(k => {
        self[k] = key[k]
      })
    }
    return self
  }

  function del (obj?: any) {
    if (obj) {
      return detach(obj)
    } else {
      // either remove references or fucka da you and dont delete.
      //    https://github.com/mobxjs/@invisr/mobx-state-tree/issues/335
      (getRoot(self) as any).del(self)
    }
  }
  function kill (obj?: any) {
    if (obj) {
      destroy(obj)
    } else {
      (getRoot(self) as any).kill(self)
    }
  }

  function moveChild (key, from, to) {
    let s = [...getSnapshot<any>(self[key])]
    s.splice(to < 0 ? s.length + to : to, 0, s.splice(from, 1)[0])
    self.update(key, s)
  }

  return { update, del, kill, moveChild }
}

export default crudActions
